import React from 'react';
import AnalyticsChart from './AnalyticsChart';
import PlatformAnalytics from './PlatformAnalytics';
import BrowserAnalytics from './BrowserAnalytics';
import CountryAnalytics from './CountryAnalytics';
import ReferrerAnalytics from './ReferrerAnalytics';

const ShortLinkAnalytics = ({ 
  analytics, 
  selectedPeriod, 
  selectedPlatform, 
  onPeriodChange, 
  onPlatformChange,
  user 
}) => {
  return (
    <>
      {/* Click Chart */}
      <div className="bg-black rounded-lg border border-gray-800 p-4 lg:p-6 mb-8">
        <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between mb-6">
          <h3 className="text-base lg:text-lg font-bold text-white mb-4 lg:mb-0">Click Chart</h3>
          <div className="flex flex-col sm:flex-row space-y-2 sm:space-y-0 sm:space-x-4">
            <select
              value={selectedPeriod}
              onChange={(e) => onPeriodChange(e.target.value)}
              className="px-3 py-2 bg-gray-800 border border-gray-700 rounded-lg text-white text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
            >
              <option value="1d">Last 24 Hours</option>
              <option value="7d">Last 7 Days</option>
              <option value="30d">Last 30 Days</option>
              <option value="90d">Last 90 Days</option>
              <option value="1y">Last 1 Year</option>
            </select>
            <select
              value={selectedPlatform}
              onChange={(e) => onPlatformChange(e.target.value)}
              className="px-3 py-2 bg-gray-800 border border-gray-700 rounded-lg text-white text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
            >
              <option value="all">All Platforms</option>
              <option value="web">Web</option>
              <option value="android">Android</option>
              <option value="ios">iOS</option>
              <option value="desktop">Desktop</option>
            </select>
          </div>
        </div>
        
        <AnalyticsChart
          data={analytics?.chartData || []}
          period={selectedPeriod}
          platform={selectedPlatform}
          userTimezone={user?.profile?.timezone}
        />
      </div>

      {/* Analytics Grid */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-8 mb-8">
        {/* Platform Analytics */}
        <div className="bg-black rounded-lg border border-gray-800 p-4 lg:p-6 flex flex-col h-full">
          <h3 className="text-base lg:text-lg font-bold text-white mb-4">Platform Distribution</h3>
          <PlatformAnalytics data={analytics?.platforms} />
        </div>

        {/* Browser Analytics */}
        <div className="bg-black rounded-lg border border-gray-800 p-4 lg:p-6 flex flex-col h-full">
          <h3 className="text-base lg:text-lg font-bold text-white mb-4">Browser Distribution</h3>
          <BrowserAnalytics data={analytics?.browsers} />
        </div>

        {/* Country Analytics */}
        <div className="bg-black rounded-lg border border-gray-800 p-4 lg:p-6 flex flex-col h-full">
          <h3 className="text-base lg:text-lg font-bold text-white mb-4">Country Distribution</h3>
          <CountryAnalytics data={analytics?.countries} />
        </div>

        {/* Referrer Analytics */}
        <div className="bg-black rounded-lg border border-gray-800 p-4 lg:p-6 flex flex-col h-full">
          <h3 className="text-base lg:text-lg font-bold text-white mb-4">Referrer Distribution</h3>
          <ReferrerAnalytics data={analytics?.referrers} />
        </div>
      </div>
    </>
  );
};

export default ShortLinkAnalytics;